import Common from "../common";

const MultiPoint = {
  /**
   * Google Maps Platform
   */
  google: null,
  /**
   * 地図
   */
  map: null,
  /**
   * Vue Map Google
   */
  vueMapGoogle: null,
  /**
   * Display map in measure mode or not
   */
  mode: false,
  /**
   * Icon
   */
  icon: null,
  /**
   * Markers
   */
  markers: [],
  /**
   * Detach long press
   */
  isLongPress     : false,
  touchSupported  : false,
  mouseDownAt     : null,
  longPressTimeout: 100,
  longPressTime   : 300,
  /**
   * 初期化
   *
   * @param mapModule
   * @param google
   * @param map
   * @param vueMapGoogle
   */
  init(mapModule, google, map, vueMapGoogle) {
    const self          = this;
    this.touchSupported = Common.hasTouchSupport();
    return new Promise((resolve) => {
      self.mapModule    = mapModule;
      self.google       = google;
      self.map          = map;
      self.vueMapGoogle = vueMapGoogle;
      self.setMode(false);
      return resolve();
    });
  },
  /**
   * Set in measure mode
   *
   * @param mode
   */
  setMode(mode) {
    this.mode = mode;
    return this;
  },
  /**
   * Get in measure mode
   *
   * @returns {boolean}
   */
  getMode() {
    return this.mode;
  },

  setMarker(position, vueMapGoogle) {
    const self = this;
    // 地番確認ウィンドウ表示中はマーカーの追加は不可
    if (vueMapGoogle.showMultiPointConfirmDialog) {
      return;
    }
    if (!self.getMode()) {
      return;
    }
    if (self.markers.length >= Common.limitMultiPoint) {
      return;
    }
    const marker = new self.google.maps.Marker({
      map     : self.map,
      position: position,
      icon    : {
        url       : `https://cdn.jon-api.com/shikaku-map/img/marker-${this.markers.length + 1}.png`,
        origin    : new this.google.maps.Point(0, 0),
        anchor    : new this.google.maps.Point(16, 48),
        scaledSize: new this.google.maps.Size(32, 48),
      }
    });

    marker.setMap(self.map);
    marker.addListener('mousedown', function () {
      self.mouseDownHandler();
    });
    marker.addListener('mouseup', function (event) {
      // 右クリックは無効
      if (event.domEvent && event.domEvent.button === 2) {
        return;
      }
      // 地番確認ウィンドウ表示中はマーカーの削除は不可
      if (vueMapGoogle.showMultiPointConfirmDialog) {
        return;
      }

      self.mouseUpHandler(event).then((e) => {
        if (e === null) {
          self.removeMarker(self.markers.indexOf(marker));
          marker.setMap(null);
          return;
        }
      });
    });
    self.markers.push(marker);
  },

  removeMarker(index) {
    this.markers = this.markers.filter((item, i) => i !== index);
    // Reindex marker
    this.markers.map((marker, i) => {
      marker.setIcon({
        url       : `https://cdn.jon-api.com/shikaku-map/img/marker-${i + 1}.png`,
        origin    : new self.google.maps.Point(0, 0),
        anchor    : new self.google.maps.Point(16, 48),
        scaledSize: new self.google.maps.Size(32, 48),
      });
    });
  },

  clearMarkers() {
    this.markers.map(maker => maker.setMap(null));
    this.markers = [];
  },

  getPoints() {
    return this.markers.map(marker => marker.position);
  },
  /**
   * Mouse down event handler
   */
  mouseDownHandler() {
    const self       = this;
    self.isLongPress = false;
    self.mouseDownAt = new Date().getTime();
  },
  mouseUpHandler(e) {
    const self       = this;
    self.isLongPress = false;
    return new Promise((resolve) => {
      // Not support touch
      if (!self.touchSupported) {
        return resolve(null);
      }
      // Not down on Map
      if (!self.mouseDownAt) {
        return resolve(null);
      }
      // Up too quickly
      const mouseUpAt = new Date().getTime();
      if (mouseUpAt - self.mouseDownAt <= self.longPressTime) {
        return resolve(null);
      }
      self.mouseDownAt = null;
      self.isLongPress = true;
      return resolve(e);
    });
  },
};

export default MultiPoint;
